import { action, runInAction } from 'mobx';
import { RouterState, RedirectFunction } from 'react-router';
import { EnvModel } from '../../env/model';
import { AccountPageModel } from './model';
import { PrismicController } from '../../prismic/controller';
import { BugsnagController } from '../../bugsnag/controller';
import { UIController } from '../../ui/controller';
import { APIController } from '../../api/controller';
import { UserModel } from '../../user/model';

export class AccountPageController {
  constructor(
    private model: AccountPageModel,
    private env: EnvModel,
    private prismic: PrismicController,
    private bugsnag: BugsnagController,
    private ui: UIController,
    private api: APIController,
    private user: UserModel
  ) {}
  
  @action
  onEnter = async (nextState: RouterState, replace: RedirectFunction) => {
    this.model.loading = true;
    const documentId = 'connected_account';

    await this.ui.setSEO(nextState.location.pathname);

    this.ui.setBreadcrumbs([{
      path: '/account',
      label: 'Account'
    }, {
      path: '/account/connected-accounts',
      label: 'Connected accounts'
    }]);

    try {
      const [{ data }] = await Promise.all([
        this.prismic.getSingle(documentId),
        this.env.ready
      ]);

      const document = data;

      runInAction(() => {
        this.model.i18n = {
          spotify: {
            header: document.spotify_title,
            content: document.spotify_content,
            link: document.spotify_link,
            unlink: document.spotify_unlink,
            unlinking: document.spotify_unlinking,
          },
          facebook: {
            header: document.facebook_title,
            content: document.facebook_content,
            link: document.facebook_link,
            unlink: document.facebook_unlink,
            unlinking: document.facebook_unlinking,
          },
          twitter: {
            header: document.twitter_title,
            content: document.twitter_content,
            link: document.twitter_link,
            unlink: document.twitter_unlink,
            unlinking: document.twitter_unlinking,
          },
          dropbox: {
            header: document.dropbox_title,
            content: document.dropbox_content,
            link: document.dropbox_link,
            unlink: document.dropbox_unlink,
            unlinking: document.dropbox_unlinking,
          },
        };
      });

    } catch (e) {
      this.bugsnag.notifyException(e);
    } finally {
      this.model.loading = false;
    }

    return;
  };
}